module.exports = __webpack_public_path__ + "static/media/clover-eco-ecology-svgrepo-com.cc6cee12.svg";